import { NgModule } from '@angular/core';
import { ResourceModule } from "../../resource/resource.module";
import { CurrenciesResourceService } from "./currencies-resource.service";
import { CachedCurrenciesService } from './cached-currencies.service';

@NgModule({
    imports: [ResourceModule],
    providers: [
        CurrenciesResourceService,
        CachedCurrenciesService,
    ],
})
export class CurrenciesResourceModule { }
